export enum ProfileMutationTypes {
  SET_PROFILE = 'SET_PROFILE',
  SET_CHECK_IN_TIME = 'SET_CHECK_IN_TIME',
  SET_CHECK_OUT_TIME = 'SET_CHECK_OUT_TIME',
  SET_BREAK_START_TIME = 'SET_BREAK_START_TIME',
  SET_BREAK_END_TIME = 'SET_BREAK_END_TIME',
  SET_ID_USER = 'SET_ID_USER',
  SET_COMMUTE_ACTION = 'SET_COMMUTE_ACTION',
}
